import type {
  AmbulanceDetailResponse,
  AmbulanceID,
  AmbulanceListResponse,
  CreateAmbulancePayload,
  CreateAmbulanceResponse,
  DeleteAmbulanceResponse,
  UpdateAmbulanceParams,
  UpdateAmbulancePayload,
  UpdateAmbulanceResponse,
} from '@/domains/asset-management/types/ambulance';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

const toUrlID = (id: string | number): string => String(id);

export const fetchAmbulanceList = async (params: string = ''): Promise<AmbulanceListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.ambulanceManagementList(params)}`;
  return await request.get(url);
};

export const fetchDetailAmbulance = async (
  ambulanceId: AmbulanceID
): Promise<AmbulanceDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailAmbulanceManagement(toUrlID(ambulanceId))}`;
  return await request.get(url);
};

export const deleteAmbulance = async (
  ambulanceId: AmbulanceID
): Promise<DeleteAmbulanceResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteAmbulanceManagement(toUrlID(ambulanceId))}`;
  return await request.delete(url);
};

export const createAmbulance = async (
  data: CreateAmbulancePayload
): Promise<CreateAmbulanceResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createAmbulanceManagement}`;
  return await request.post(url, data);
};

export const updateAmbulance = async (
  data: UpdateAmbulancePayload,
  params: UpdateAmbulanceParams
): Promise<UpdateAmbulanceResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateAmbulanceManagement(toUrlID(params.ambulance_id))}`;
  return await request.put(url, data);
};
